// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var UserSession = require("../../common/UserSession/UserSession.bs.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function getFirstCharacter(str) {
  return str.slice(0, 1);
}

function ClientAccess__Components__Avatar(props) {
  var __usePlaceholder = props.usePlaceholder;
  var __size = props.size;
  var size = __size !== undefined ? __size : "normal";
  var usePlaceholder = __usePlaceholder !== undefined ? __usePlaceholder : false;
  var clientInfo = UserSession.useClientInfoOpt();
  var tmp;
  if (usePlaceholder) {
    tmp = JsxRuntime.jsx("img", {
          className: "block w-full h-full object-cover",
          src: AvatarSrcUrl.place_holder
        });
  } else if (clientInfo !== undefined) {
    var match = clientInfo.profilePhoto;
    if (match !== undefined) {
      var profilePictureSize = size === "normal" ? 50 : 40;
      tmp = JsxRuntime.jsx("img", {
            className: "block w-full h-full object-cover",
            src: AvatarSrcUrl.from_key(profilePictureSize, profilePictureSize, match.key)
          });
    } else {
      var initials = clientInfo.firstName.slice(0, 1) + clientInfo.lastName.slice(0, 1);
      tmp = JsxRuntime.jsx("span", {
            children: initials,
            className: TailwindMerge.twMerge([
                  "text-gray-600 uppercase font-normal",
                  size === "normal" ? "text-[22px]" : "text-lg"
                ])
          });
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: TailwindMerge.twMerge([
                    "flex shrink-0 rounded-full justify-center items-center overflow-hidden bg-gray-100",
                    size === "normal" ? "w-10 h-10" : "w-[30px] h-[30px]"
                  ])
            });
}

var make = ClientAccess__Components__Avatar;

exports.getFirstCharacter = getFirstCharacter;
exports.make = make;
/* UserSession Not a pure module */
